import { Link } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../lib/api";

export const BackHome = () => (
  <div className="max-w-6xl mx-auto px-6 pt-8">
    <Link
      to="/"
      data-testid="back-home-link"
      className="inline-flex items-center gap-2 text-sm body-text hover:text-[#3ecf8e] transition-colors"
    >
      <ArrowLeft size={16} /> Retour à l'accueil
    </Link>
  </div>
);

export const StatBlock = ({ stats, testId }) => (
  <div className="grid grid-cols-2 gap-4 md:gap-6" data-testid={testId}>
    {stats.map((s, i) => (
      <div key={i} className="card-base text-center">
        <p className="title-text font-extrabold text-3xl md:text-4xl">{s.value}</p>
        <p className="text-xs md:text-sm body-text uppercase tracking-wider mt-2 font-semibold">
          {s.label}
        </p>
      </div>
    ))}
  </div>
);

export const SectionHeader = ({ badge, title, accentTitle, subtitle, centered = true }) => (
  <div className={`mb-12 ${centered ? "text-center" : ""}`}>
    {badge && <span className="pill-badge mb-5 inline-flex">{badge}</span>}
    <h2 className="section-title">
      {title} <span className="accent-text">{accentTitle}</span>
    </h2>
    {subtitle && (
      <p className="body-text mt-5 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
    )}
  </div>
);

export const ProcessCard = ({ num, badge, Icon, title, text }) => (
  <div className="card-base h-full fade-in">
    <div className="flex items-center justify-between mb-5">
      <span className="text-3xl font-extrabold title-text opacity-30">{num}</span>
      <span className="pill-badge !text-[0.6rem] !py-1 !px-3">{badge}</span>
    </div>
    <span className="icon-square mb-5">
      <Icon size={24} />
    </span>
    <h4 className="text-lg font-bold title-text mb-2">{title}</h4>
    <p className="body-text text-sm leading-relaxed">{text}</p>
  </div>
);

export const FeatureCard = ({ num, Icon, title, text }) => (
  <div className="card-base h-full fade-in">
    <div className="flex items-center justify-between mb-5">
      <span className="icon-square">
        <Icon size={24} />
      </span>
      <span className="text-3xl font-extrabold title-text opacity-20">{num}</span>
    </div>
    <h4 className="text-lg font-bold title-text mb-2">{title}</h4>
    <p className="body-text text-sm leading-relaxed">{text}</p>
  </div>
);

export const GreenCta = ({ badge, title, subtitle, primaryLabel, primaryAction, secondaryLabel, secondaryAction, footnotes }) => (
  <section className="px-6 py-16">
    <div className="max-w-5xl mx-auto rounded-3xl p-10 md:p-16 fade-in" style={{ background: "linear-gradient(135deg,#3ecf8e 0%,#2db97a 100%)" }}>
      {badge && <span className="pill-badge-dark mb-6">{badge}</span>}
      <h2 className="text-white font-extrabold text-3xl md:text-5xl leading-tight mb-5">
        {title}
      </h2>
      {subtitle && <p className="text-white/90 max-w-2xl mb-8 leading-relaxed">{subtitle}</p>}
      <div className="flex flex-col sm:flex-row gap-4 flex-wrap">
        {primaryLabel && (
          <button onClick={primaryAction} className="btn-outline-white" data-testid="green-cta-primary">
            {primaryLabel}
          </button>
        )}
        {secondaryLabel && (
          <a
            href={secondaryAction || WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-dark"
            data-testid="green-cta-secondary"
          >
            <MessageCircle size={18} /> {secondaryLabel}
          </a>
        )}
      </div>
      {footnotes && (
        <p className="text-white/80 text-sm mt-6 flex flex-wrap gap-4">
          {footnotes.map((f, i) => (
            <span key={i}>✓ {f}</span>
          ))}
        </p>
      )}
    </div>
  </section>
);
